import React, { useState } from "react";
import { toast } from "react-toastify";
import * as hrmsService from "../../services/hrmsService";

// The platform role of an employee's login, with the one change that is allowed afterwards: Support <-> HR, by the
// owner or an Admin. Admin and Crew are fixed (Admin grants everything; Crew has bookings and shifts attached), as is
// the owner; for those the answer to a wrong role is to end employment and add the person again.
export const ROLE_LABELS = { 2: "Admin", 3: "Owner", 5: "Crew", 6: "Support", 7: "HR" };
const SWITCH = { 6: 7, 7: 6 };

export default function RoleControl({ employeeId, role, canChange, onDone }) {
  const [saving, setSaving] = useState(false);
  const current = Number(role) || null;
  const target = SWITCH[current];
  const label = ROLE_LABELS[current] || "—";

  const change = async () => {
    if (!window.confirm(`Change this person's role from ${label} to ${ROLE_LABELS[target]}? What they can open on the platform changes straight away.`)) return;
    setSaving(true);
    try {
      const res = await hrmsService.changeEmployeeRole(employeeId, target);
      if (res?.success) {
        toast.success(res.message || "Role changed");
        onDone && onDone();
      } else toast.error(hrmsService.responseMessage(res));
    } finally {
      setSaving(false);
    }
  };

  return (
    <span>
      {label}
      {canChange && target ? (
        <button type="button" className="btn btn-link btn-sm py-0" onClick={change} disabled={saving}>
          Change to {ROLE_LABELS[target]}
        </button>
      ) : null}
    </span>
  );
}
